module.exports = global["$"] = require("-!D:\\my_projects\\fpmcms\\edu-dev\\node_modules\\source-map-loader\\index.js!D:\\my_projects\\fpmcms\\edu-dev\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/source-map-loader!./node_modules/jquery/dist/jquery.js-exposed
// module id = ./node_modules/expose-loader/index.js?$!./node_modules/source-map-loader/index.js!./node_modules/jquery/dist/jquery.js-exposed
// module chunks = 5